// Prefer User-Agent Client Hints (`navigator.userAgentData.platform`) over the
// UA string: it survives UA reduction and is harder to spoof. Fall back to the
// UA regex on browsers without UA-CH (Safari, Firefox).

export function isAndroid() {
    const platform = navigator.userAgentData?.platform;
    if (platform) return platform === 'Android';
    return /Android/i.test(navigator.userAgent || '');
}

export function isApple() {
    // iOS Safari doesn't ship UA-CH, so the UA fallback is authoritative there.
    return /iPhone|iPad|iPod/i.test(navigator.userAgent || '');
}
